import organisationsData from '../data/organisations.json';

const BASE_URL = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/CommGames2026/microplus';
const ENV = 'prod'; // Change to 'prod' or 'uat when ready

const endpoints = {
  medals: `${BASE_URL}/${ENV}/medals/latest.json`,
  schedule: `${BASE_URL}/${ENV}/schedule/latest.json`,
  scheduleAus: `${BASE_URL}/${ENV}/schedule-aus/latest.json`, // Always prod for Aussies
  results: `${BASE_URL}/${ENV}/results/latest.json`,
  winners: `${BASE_URL}/${ENV}/medals-winners/latest.json`
};

export const fetchMedals = async () => {
  try {
    const response = await fetch(endpoints.medals);
    if (!response.ok) throw new Error(`Medals fetch failed: ${response.status}`);
    const data = await response.json();
    return data.Data || [];
  } catch (error) {
    console.error('Error fetching medals:', error);
    throw error;
  }
};

export const fetchOrganisations = async () => {
  return organisationsData || [];
};

export const fetchSchedule = async () => {
  try {
    const response = await fetch(endpoints.schedule);
    if (!response.ok) throw new Error(`Schedule fetch failed: ${response.status}`);
    const data = await response.json();
    return data.Data || [];
  } catch (error) {
    console.error('Error fetching schedule:', error);
    throw error;
  }
};

export const fetchScheduleAus = async () => {
  try {
    const response = await fetch(endpoints.scheduleAus);
    if (!response.ok) throw new Error(`Schedule (Aus) fetch failed: ${response.status}`);
    const data = await response.json();
    return data.Data || [];
  } catch (error) {
    console.error('Error fetching schedule (Aus):', error);
    throw error;
  }
};

export const fetchResults = async () => {
  try {
    const response = await fetch(endpoints.results);
    if (!response.ok) throw new Error(`Results fetch failed: ${response.status}`);
    const data = await response.json();
    return data.Data || [];
  } catch (error) {
    console.error('Error fetching results:', error);
    throw error;
  }
};

export const fetchWinners = async () => {
  try {
    const response = await fetch(endpoints.winners);
    if (!response.ok) throw new Error(`Winners fetch failed: ${response.status}`);
    const data = await response.json();
    return data.Data || [];
  } catch (error) {
    console.error('Error fetching winners:', error);
    throw error;
  }
};
